/* tslint:disable */
/* eslint-disable */
/**
 * Telematics backend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface VehicleCharging
 */
export interface VehicleCharging {
    /**
     * 
     * @type {Date}
     * @memberof VehicleCharging
     */
    time: Date;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleCharging
     */
    on: boolean;
}

export function VehicleChargingFromJSON(json: any): VehicleCharging {
    return VehicleChargingFromJSONTyped(json, false);
}

export function VehicleChargingFromJSONTyped(json: any, ignoreDiscriminator: boolean): VehicleCharging {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'time': (new Date(json['time'])),
        'on': json['on'],
    };
}

export function VehicleChargingToJSON(value?: VehicleCharging | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'time': (value.time.toISOString()),
        'on': value.on,
    };
}


